<div class="d-flex justify-content-end mb-n2">
  <div class="btn-group btn-group-sm" role="group">
    <button type="button" class="btn"
            [class.btn-info]="displayMode === 'short'"
            [class.btn-outline-info]="displayMode !== 'short'"
            (click)="toggleDisplayMode('short')">
      Short Spikes
    </button>
    <button type="button" class="btn"
            [class.btn-info]="displayMode === 'long'"
            [class.btn-outline-info]="displayMode !== 'long'"
            (click)="toggleDisplayMode('long')">
      Long Holds
    </button>
  </div>
</div>
<div class="heatmap" style="max-height: 320px;">
  @if (ready) {
    <ngx-charts-heat-map class="dark"
      [scheme]="colorScheme"
      [legend]="legend"
      [tooltipText]="tooltipText"
      [animations]="animations"
      [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel"
      [min]="min"
      [max]="max"
      [xAxis]="xAxis"
      [yAxis]="yAxis"
      [results]="chartData">
    </ngx-charts-heat-map>
  }
  @if (!ready) {
    <div class="d-flex justify-content-center align-items-center" style="height: 320px;">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }
</div>